import {
  IconMap,
  SelectorCheckable,
  SelectorItem,
} from '@/components/treeSelector/components/SelectorItem';
import { FlatTreeNode } from '@/components/treeSelector/types/tree';
import { cn } from '@/lib/utils';
import { ClassNameProp } from '@/types/react';
import { ComponentProps } from 'react';

export const LeafNode = <T extends string>({
  children,
  flatNode,
  type,
  iconMap,
  checked,
  onClick,
  className,
  iconClassName,
  iconWrapperClassName,
}: Pick<ComponentProps<typeof SelectorCheckable>, 'checked' | 'onClick'> & {
  flatNode: FlatTreeNode;
  type: T;
  iconMap: IconMap<T>;
  iconClassName?: string;
  iconWrapperClassName?: string;
} & { children: React.ReactNode } & ClassNameProp) => {
  return (
    <div
      className={cn('flex h-8 items-center', className)}
      style={{ paddingLeft: `${flatNode.level * 27}px` }}
    >
      <SelectorCheckable
        aria-label={`${type} ${flatNode.node.label}`}
        checked={checked}
        onClick={onClick}
      >
        <SelectorItem
          type={type}
          className="pl-6"
          iconMap={iconMap}
          iconClassName={iconClassName}
          iconWrapperClassName={iconWrapperClassName}
        >
          {children}
        </SelectorItem>
      </SelectorCheckable>
    </div>
  );
};
